import { render, staticRenderFns } from "./VerticalFavourite.vue?vue&type=template&id=48979e37"
import script from "./VerticalFavourite.vue?vue&type=script&lang=js"
export * from "./VerticalFavourite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports